<template>
  <v-container fluid style="max-width: 1280px;">
    <v-layout align-start>
      <v-flex>
        <template v-if="esAdministrador || esUsuario">
          <v-row align="center" justify="center">
            <v-col cols="6" md="3" sm="3">
              <v-card class="mx-auto text-center" :color="$vuetify.theme.themes.light.primary" dark max-width="600">
                <v-card-text>
                  <v-sheet color="rgba(0, 0, 0, .12)">
                    <div class="text-lg-h6">{{ cantidadCPE }}</div>
                  </v-sheet>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                  <v-btn block text x-small @click="irGuiasRemision()">Guías de Remisión Emitidas</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>

          <v-row align="center" justify="center">
            <v-col cols="12">
              <v-card class="mx-auto text-center" :color="$vuetify.theme.themes.light.primary">
                <v-card-text class="text-lg-h6 white--text">TOTALES POR RUTA
                  <v-row align="center" justify="center">
                    <v-col>
                      <v-card class="elevation-3">
                        <v-card-text>
                          <div>
                            <canvas id="rutasBar"></canvas>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="justify-center">
                  <v-col cols="3" md="2" sm="3">
                    <v-select dense :items="aanos" v-model="eano" label="AÑO"
                      @change="selectEntrega(eano), totalCarga()" dark required hide-details></v-select>
                  </v-col>
                  <v-col cols="3" md="2" sm="2">
                    <v-select dense :items="anro_entregas" v-model="enro_entrega" label="ENTREGA" @change="totalCarga()"
                      dark required hide-details></v-select>
                  </v-col>
                  <v-col cols="6" md="4" sm="4">
                    <v-select dense :items="aitems" v-model="eitem" @change="totalCarga()" label="ITEM" dark required
                      hide-details></v-select>
                  </v-col>
                </v-card-actions>
                <v-card-text>
                  <v-row align="center" justify="center">
                    <v-col cols="10">
                      <v-data-table :headers="headRuta" :items="cargaTotales" dense disable-pagination
                        hide-default-footer>
                        <template v-slot:item.totpresentacion="{ item }">
                          {{ item.totpresentacion.toFixed(3) }}
                        </template>
                        <template slot="body.append">
                          <tr>
                            <td class="text-right font-weight-bold">TOTAL:</td>
                            <td class="text-right font-weight-bold">{{ totalCodmodular }}</td>
                            <td class="text-right font-weight-bold">{{ totalCantidad }}</td>
                            <td class="text-right font-weight-bold">{{ totalPresentacion }}</td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import Chart from "chart.js";
import moment from "moment";
import { mapState, mapGetters } from "vuex"; //Importamos para llamar a los elementos

export default {
  data() {
    return {
      headRuta: [
        { text: "RUTAS", value: "ruta", sortable: false, align: "center" },
        { text: "IES", value: "totcodmodular", sortable: false, align: "right" },
        { text: "PRODUCTOS", value: "totcantidad", sortable: false, align: "right" },
        { text: "PESO", value: "totpresentacion", sortable: false, align: "right" },
      ],

      totalCodmodular: "",
      totalCantidad: "",
      totalPresentacion: "",

      // Variables total dia
      resumen_dia: [],
      // variables total meses
      cantidadCPE: 0,
      cargaTotales: [],
      enro_entrega: 1,
      eitem: "1",
      anro_entregas: [],
      aitems: [],
      aanos: [
        { text: '2023' },
        { text: '2024' },
        { text: '2025' },
        { text: '2026' },
      ],
      eano: moment().format("YYYY"),
    };
  },
  computed: {
    ...mapState(["usuario"]), // Llamamos a state para usuario
    ...mapGetters(["esAdministrador", "esUsuario"]),
  },

  created() {
    this.comprobantesEmitidos();
    this.selectItem();
    this.selectEntrega(this.eano);
    this.totalCarga();
  },

  methods: {

    irGuiasRemision() {
      this.$router.push({ name: "guiasremision" }).catch(() => { });
    },

    selectEntrega(ano) {
      let me = this;
      var entregasArray = [];

      axios.get("api/Cargas/SelectCarga/" + ano)
        .then(function (response) {
          entregasArray = response.data;
          entregasArray.map(function (x) {
            me.anro_entregas.push({
              text: x.nro_entrega,
            });
          });
        })
        .catch(function (error) { });
    },

    selectItem() {
      let me = this;

      var item_entradasArray = [];
      axios.get("api/Item_Entregas/Select")
        .then(function (response) {
          item_entradasArray = response.data;
          item_entradasArray.map(function (x) {
            me.aitems.push({
              text: x.nombre,
              value: x.item,
            });
          });
        })
        .catch(function (error) { });
    },


    comprobantesEmitidos() {
      let me = this;
      var cantidadCPEArray = [];
      axios.get("api/Movimientos/totalCPE")
        .then(function (response) {
          cantidadCPEArray = response.data;
          for (var i = 0; i < cantidadCPEArray.length; i++) {
            me.cantidadCPE = me.cantidadCPE + cantidadCPEArray[i].cantidad;
          }
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    totalCarga() {
      let me = this;

      var cargaArray = [];
      axios.get("api/Cargas/ListarTotalRuta", {
        params: {
          ano: me.eano,
          nro_entrega: me.enro_entrega,
          item: me.eitem,
        }
      })
        .then(function (response) {
          cargaArray = response.data;
          me.cargaTotales = cargaArray;
          //console.log(cargaArray)

          // Inicializar el total con reduce
          let total = me.cargaTotales.reduce((acumulador, item) => {
            return {
              totcodmodular: acumulador.totcodmodular + item.totcodmodular,
              totcantidad: acumulador.totcantidad + item.totcantidad,
              totpresentacion: acumulador.totpresentacion + item.totpresentacion
            };
          }, { totcodmodular: 0, totcantidad: 0, totpresentacion: 0 });

          me.totalCodmodular = total.totcodmodular;
          me.totalCantidad = total.totcantidad;
          me.totalPresentacion = total.totpresentacion.toFixed(3);

          me.cargarGraficoBar(cargaArray)
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    cargarGraficoBar(items) {
      let me = this;

      // Extraer datos de items de forma más compacta
      let rutaLavel = items.map(x => x.ruta);
      let totcodmodular = items.map(x => x.totcodmodular);
      let totcantidad = items.map(x => x.totcantidad);
      let totpresentacion = items.map(x => x.totpresentacion);

      // Obtener el canvas
      let canvas = document.getElementById("rutasBar");

      // Verificar si ya existe un gráfico, si es así, destruirlo
      if (me.rutasBar) {
        me.rutasBar.destroy();
      }

      // Limpiar el canvas antes de crear el nuevo gráfico
      canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);

      // Crear nuevo gráfico y almacenarlo en me.rutasBar
      me.rutasBar = new Chart(canvas, {
        type: "bar",
        data: {
          labels: rutaLavel,
          datasets: [
            {
              data: totcodmodular,
              label: "IES",
              backgroundColor: "#4F98C2",
              stack: "Stack 0",
            },
            {
              data: totcantidad,
              label: "PRODUCTOS",
              backgroundColor: "#F4A261",
              stack: "Stack 0",
            },
            {
              data: totpresentacion,
              label: "PESO",
              backgroundColor: "#7CBA5D",
              stack: "Stack 0",
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          /* plugins: {
            title: {
              display: true,
              text: "RUTAS",
              position: "bottom",
            },
          }, */
        },
      });
    },

  },
};
</script>